import React from "react";
import { LifeBuoy, Phone, MessageCircle, Siren, Info } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { SectionLayout, SectionIntro, Panel } from "@/components/SectionLayout";

export const Support = ({ data }) => {
  const { L, t } = useLang();
  if (!data) return null;

  return (
    <SectionLayout id="support" icon={LifeBuoy}>
      <SectionIntro>{L(data.intro)}</SectionIntro>

      <h2 className="mb-3 font-display text-2xl font-medium text-[#0A192F]">{t("support.contacts")}</h2>
      <div className="space-y-3">
        {(data.contacts || []).map((c) => (
          <Panel key={c.id} data-testid={`contact-${c.id}`}>
            <p className="text-[11px] uppercase tracking-[0.16em] text-[#D4AF37] font-semibold">{L(c.role)}</p>
            <h3 className="mt-0.5 font-display text-xl font-medium text-[#0A192F]">{L(c.name)}</h3>
            <div className="mt-3 flex flex-wrap gap-2">
              {c.phone && (
                <a
                  href={`tel:${c.phone}`}
                  className="inline-flex items-center gap-1.5 rounded-full bg-[#0A192F] px-4 py-2 text-sm font-medium text-white transition-transform hover:-translate-y-0.5"
                >
                  <Phone size={15} /> {t("call")}
                </a>
              )}
              {c.whatsapp && (
                <a
                  href={`https://wa.me/${String(c.whatsapp).replace(/[^0-9]/g, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1.5 rounded-full border border-[#2E7D32]/30 px-4 py-2 text-sm font-medium text-[#2E7D32] transition-colors hover:bg-[#2E7D32]/8"
                >
                  <MessageCircle size={15} /> {t("whatsapp")}
                </a>
              )}
            </div>
          </Panel>
        ))}
      </div>

      {Array.isArray(data.emergency) && data.emergency.length > 0 && (
        <>
          <h2 className="mb-3 mt-8 font-display text-2xl font-medium text-[#0A192F]">{t("support.emergency")}</h2>
          <Panel className="border-[#C62828]/20 bg-gradient-to-br from-[#FBEBEB] to-white">
            <ul className="space-y-2.5">
              {data.emergency.map((e, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm font-medium text-[#0A1128]/80">
                  <Siren size={16} className="mt-0.5 shrink-0 text-[#C62828]" />
                  {L(e)}
                </li>
              ))}
            </ul>
          </Panel>
        </>
      )}

      {data.lostTraveler && (
        <>
          <h2 className="mb-3 mt-8 font-display text-2xl font-medium text-[#0A192F]">{t("support.lost")}</h2>
          <Panel className="bg-gradient-to-br from-[#F1F5F9] to-white">
            <div className="flex items-start gap-3">
              <Info size={20} className="mt-0.5 shrink-0 text-[#D4AF37]" />
              <p className="text-sm font-light leading-relaxed text-[#0A1128]/75">{L(data.lostTraveler)}</p>
            </div>
          </Panel>
        </>
      )}
    </SectionLayout>
  );
};
